import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingOverlayService {
  private activeHttpCalls: string[] = [];

  private loadingDisplaySubject = new BehaviorSubject<boolean>(false);
  loadingDisplayObservable = this.loadingDisplaySubject.asObservable();

  addHttpActiveCall(url: string): void {
    this.activeHttpCalls.push(url);
    this.validateLoadingDisplay();
  }

  removeHttpActiveCall(url: string): void {
    const activeCallIndex = this.activeHttpCalls.findIndex(
      (activeHttpCall) => activeHttpCall === url
    );
    this.activeHttpCalls.splice(activeCallIndex, 1);
    this.validateLoadingDisplay();
  }

  private validateLoadingDisplay(): void {
    const isCamera = this.activeHttpCalls.some((e : any) => (!e.includes("/start") && !e.includes("/cctv/api/v1/camera-streaming/")))
    const activeCallsCount = this.activeHttpCalls.length;
    const isLoadingVisible = activeCallsCount > 0 && isCamera;
    this.loadingDisplaySubject.next(isLoadingVisible);
  }
}
